import { styled } from '@mui/material';

import { FC } from 'react';

import { Button } from './Button';

const StyledSkipToMainContentButton = styled(Button)(({ theme }) => ({
  '&:focus': {
    backgroundColor: theme.palette.white.main,
    height: 'auto',
    left: theme.spacing(4),
    width: 'auto'
  },
  height: 0,
  left: -10000,
  overflow: 'hidden',
  position: 'absolute',
  top: 'auto',
  width: 0
}));

export const SkipToMainContentButton: FC = () => {
  return (
    <StyledSkipToMainContentButton href='#mainContent' variant='outlined'>
      Skip to Main Content
    </StyledSkipToMainContentButton>
  );
};

SkipToMainContentButton.displayName = 'SkipToMainContentButton';
